import {
  ADD_PARTICIPANTS_INVITES,
  EDIT_PARTICIPANTS_INVITES,
  LIST_PARTICIPANTS_INVITES,
  VIEW_PARTICIPANTS_INVITES,
  DELETE_PARTICIPANTS_INVITES,
  // text
  ADD_PARTICIPANTS_INVITES_TEXT,
  EDIT_PARTICIPANTS_INVITES_TEXT,
  LIST_PARTICIPANTS_INVITES_TEXT,
  VIEW_PARTICIPANTS_INVITES_TEXT,
  DELETE_PARTICIPANTS_INVITES_TEXT,
  PARTICIPANTS_INVITES_SUCCESS,
  PARTICIPANTS_INVITES_ERROR,
} from "./actionTypes"

// add partcipants invites
export const addParticipantsInvites = (data, history, callback) => {
  return {
    type: ADD_PARTICIPANTS_INVITES,
    payload: { data, history, callback }
  }
}

// edit partcipants invites
export const editParticipantsInvites = (data, id, callback) => {
  return {
    type: EDIT_PARTICIPANTS_INVITES,
    payload: { data, id, callback },
  }
}

// list partcipants invites
export const listParticipantsInvites = (data, callback) => {
  return {
    type: LIST_PARTICIPANTS_INVITES,
    payload: { data, callback },
  }
}

// view partcipants invites
export const viewParticipantsInvites = (data, history) => {
  return {
    type: VIEW_PARTICIPANTS_INVITES,
    payload: { data, history },
  }
}

// delete partcipants invites
export const deleteParticipantsInvites = (data, callback) => {
  return {
    type: DELETE_PARTICIPANTS_INVITES,
    payload: { data, callback },
  }
}

// text
// add Invites
export const addParticipantsInvitesText = (data, history, callback) => {
  return {
    type: ADD_PARTICIPANTS_INVITES_TEXT,
    payload: { data, history, callback }
  }
}

// edit Invites
export const editParticipantsInvitesText = (data, id, callback) => {
  return {
    type: EDIT_PARTICIPANTS_INVITES_TEXT,
    payload: { data, id, callback },
  }
}

// list Invites
export const listParticipantsInvitesText = (data, id, callback) => {
  return {
    type: LIST_PARTICIPANTS_INVITES_TEXT,
    payload: { data, id, callback },
  }
}

// view Invites
export const viewParticipantsInvitesText = (data, history) => {
  return {
    type: VIEW_PARTICIPANTS_INVITES_TEXT,
    payload: { data, history },
  }
}

// delete Invites
export const deleteParticipantsInvitesText = (data, callback) => {
  return {
    type: DELETE_PARTICIPANTS_INVITES_TEXT,
    payload: { data, callback },
  }
}

export const participantsInvitesSuccess = message => {
  return {
    type: PARTICIPANTS_INVITES_SUCCESS,
    payload: message,
  }
}

export const participantsInvitesError = message => {
  return {
    type: PARTICIPANTS_INVITES_ERROR,
    payload: message,
  }
}
